module.exports = __webpack_public_path__ + "img/Creat claim.b1bd26ba.jpg";